import { useContext } from '@nuxtjs/composition-api'

import { useProductStore } from '~/store/product'

import useAnalytics from '@/composables/analytics/useAnalytics'
import { ReferencedProduct } from '~/types/product/productTypes'

export default () => {
  const context = useContext()
  const analytics = useAnalytics()

  const trackCarouselView = () => {
    const params = {
      ga4: {
        event: 'carousel_view',
        ...analytics.getCustomDimensions().ga4,
      },
    }

    context.$gtm.push(params.ga4)
  }

  const trackProductView = (productId: string) => {
    const params = {
      ga4: {
        event: 'view_item',
        items: [generateItemParams(productId)],
        ...analytics.getCustomDimensions().ga4,
      },
    }
    context.$gtm.push(params.ga4)
  }

  const trackProductListImpressions = (referencedProducts: ReferencedProduct[], title: string) => {
    if (!referencedProducts.length) {
      return
    }
    const params = {
      ga4: {
        event: 'view_item_list',
        item_list_name: title,
        items: referencedProducts,
        ...analytics.getCustomDimensions().ga4,
      },
    }
    context.$gtm.push(params.ga4)
  }

  const trackProductClick = () => {
    context.$gtm.push({
      event: 'e_productClick',
      ...analytics.getCustomDimensions().ga4,
    })
  }

  const generateItemParams = (productId: string) => {
    const product = useProductStore().products[productId].data
    return {
      id: product.key,
      name: product.name,
      category: product.productCategory,
      type: product.productType,
    }
  }

  const trackCitationClick = (text: string, url: string) => {
    const params = {
      ga4: {
        event: 'citation_engagement',
        citation_text: text,
        citation_engagement_location: url,
        ...analytics.getCustomDimensions().ga4,
      },
    }
    context.$gtm.push(params.ga4)
  }

  return {
    trackCarouselView,
    trackProductView,
    trackProductListImpressions,
    trackProductClick,
    trackCitationClick,
  }
}
